import { render, staticRenderFns } from "./SimpleIconPicker.vue?vue&type=template&id=03756c66&"
import script from "./SimpleIconPicker.vue?vue&type=script&lang=js&"
export * from "./SimpleIconPicker.vue?vue&type=script&lang=js&"
import style0 from "./SimpleIconPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports